import {_Sitemap} from '@localization/siteMap/breadcrumbs/_Sitemap.ts';
import {pointer} from '@models/helpers.ts';
import React from "react";
import {
    Alert,
    AlertColor,
    Divider,
    Grid,
    Link,
    List,
    ListItem,
    Stack,
    SwipeableDrawer,
    Typography,
} from "@mui/material";
import {Link as RouterLink} from "react-router-dom";
import {useAlert} from "@contexts/hooks/useAlert.ts";
import {ToDateTimeDefault} from "@shared/MathHelp.ts";
import {useNavigate} from "react-router";
import {AlterarStatusNotificacao} from "@components/usuario/endpoints/__usuarios_endpoints.ts";

interface NotificationDrawerProps {
    open: boolean;
    setOpen: (open: boolean) => void;
}

export const NotificationDrawer: React.FC<NotificationDrawerProps> = ({open, setOpen}) => {
    const {getNotificacoes, createAlertFromResponse} = useAlert();

    const notificacoes = getNotificacoes();
    const navigate = useNavigate();


    return (<SwipeableDrawer open={open}
                             anchor={'right'}
                             onClose={() => {
                                 setOpen(false);
                             }}
                             onOpen={() => {
                                 setOpen(true);
                             }}
    >
        <List sx={{width: 250}}>
            <ListItem key={'text'}>
                <Typography variant={'overline'} component={RouterLink}
                            to={_Sitemap.notificacoes.children.minhas.fullUrl}
                >Notificações</Typography>
            </ListItem>
            <Divider/>
            <ListItem>
                <Grid container justifyContent={'space-between'}>
                    <Grid>
                        <Typography variant={'caption'}>Você
                            tem {notificacoes?.pagination?.total} novas notificações</Typography>
                    </Grid>
                    <Grid>
                        {notificacoes && notificacoes.items.length > 0 && <Typography component={Link}
                                                                                      variant={'caption'}
                                                                                      onClick={() => {
                                                                                          notificacoes.items?.forEach(x => {
                                                                                              AlterarStatusNotificacao({
                                                                                                  lida: true,
                                                                                                  idNotificacao: x.id,
                                                                                              }).then((x) => {
                                                                                                  createAlertFromResponse(x);
                                                                                              });
                                                                                          });

                                                                                      }}>Marcar todas visiveis como
                            lidas
                        </Typography>}
                    </Grid>
                </Grid>
            </ListItem>
            <Divider/>
            {notificacoes?.items && notificacoes.items.map((x, index) =>
                <Grid container key={index}>
                    {/*                    <Grid size={1} component={Paper}>

                    </Grid>*/}
                    <Grid size={12}>
                        <Grid container
                              p={1}
                              direction={'row-reverse'}
                              key={x.id}
                              alignItems={'center'}
                              spacing={1}>
                            <Stack maxWidth={'100%'} width={'100%'} spacing={1}>
                                <Alert
                                    severity={x.tipo.toLowerCase() as AlertColor}>
                                    <Grid>
                                        <Grid size={12}>
                                            <Typography variant={'caption'}>{x.mensagem}</Typography>
                                        </Grid>
                                        <Grid size={12}>
                                            <Grid container justifyContent={'end'}>
                                                <Grid>
                                                    <Typography variant={'caption'}
                                                                color={'text.secondary'}
                                                                fontSize={'small'}
                                                                justifyContent={'flex-end'}
                                                                sx={{
                                                                    maxWidth: '100%',
                                                                    width: '100%',
                                                                }}>{ToDateTimeDefault(x.data)}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid size={12}>
                                            <Grid container justifyContent={'space-between'}>
                                                <Link sx={{...pointer}} onClick={() => {
                                                    AlterarStatusNotificacao({
                                                        lida: true,
                                                        idNotificacao: x.id,
                                                    }).then((x) => {
                                                        createAlertFromResponse(x);
                                                    });
                                                }}>
                                                    Ok
                                                </Link>
                                                <Link variant={'caption'}
                                                      color={x.urlAoClicar ? 'primary' : 'text.secondary'}
                                                      fontSize={'small'}
                                                      onClick={() => {
                                                          if (x.urlAoClicar) {
                                                              navigate(x.urlAoClicar ?? '', {
                                                                  relative: 'route',
                                                              });
                                                              setOpen(false);
                                                          }
                                                      }}
                                                      sx={{
                                                          cursor: x.urlAoClicar ? 'pointer' : 'default',
                                                      }}
                                                >Ir
                                                </Link>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Alert>
                            </Stack>
                        </Grid>
                    </Grid>
                </Grid>,
            )}
        </List>
    </SwipeableDrawer>);
};